var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container content-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[(!_vm.notFound)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.notFound)?_c('not-found-content'):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }